export enum EIr8aAmountStatus {
  recorded = 'recorded',
  approved = 'approved',
}
